import { render } from "./PremiumPlaceholder.vue?vue&type=template&id=de94a81e"
import script from "./PremiumPlaceholder.vue?vue&type=script&lang=js"
export * from "./PremiumPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__